"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.v2Transformer = exports.getBillableLineItems = exports.calculatePriceSummary = exports.getNestedItems = void 0;
var Types_1 = require("./Types");
var currency_formatter_1 = __importDefault(require("currency-formatter"));
var lodash_1 = require("lodash");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var Types_2 = require("@CommonFrontendBackend/QuoteV2/Types");
var roundOffMoney = function (amount, currencyCode) {
    var currencyDecimals = currency_formatter_1.default.findCurrency(currencyCode).decimalDigits;
    var multiplier = Math.pow(10, currencyDecimals);
    return Math.round(amount * multiplier) / multiplier;
};
var stubTotals = function (items, ctx) {
    var e_1, _a, e_2, _b;
    var _c, _d, _e, _f;
    var total = {};
    try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var item = items_1_1.value;
            if ("includedInQuote" in item && !item.includedInQuote) {
                continue;
            }
            var frequencies = Object.keys(item.total);
            try {
                for (var frequencies_1 = (e_2 = void 0, __values(frequencies)), frequencies_1_1 = frequencies_1.next(); !frequencies_1_1.done; frequencies_1_1 = frequencies_1.next()) {
                    var frequency = frequencies_1_1.value;
                    var base = roundOffMoney(((_d = (_c = total[frequency]) === null || _c === void 0 ? void 0 : _c.base) !== null && _d !== void 0 ? _d : 0) + ((_f = (_e = item.total[frequency]) === null || _e === void 0 ? void 0 : _e.quoted) !== null && _f !== void 0 ? _f : 0), ctx.currency);
                    total[frequency] = {
                        base: base,
                        discounts: [],
                        quoted: base,
                        taxes: [],
                        billable: 0,
                    };
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (frequencies_1_1 && !frequencies_1_1.done && (_b = frequencies_1.return)) _b.call(frequencies_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return total;
};
var buildBasePriceSummary = function (quoteData, _a) {
    var e_3, _b, e_4, _c, e_5, _d, _e, _f;
    var ctx = _a.ctx;
    var blocks = [];
    try {
        for (var _g = __values(quoteData.blocks), _h = _g.next(); !_h.done; _h = _g.next()) {
            var block = _h.value;
            var sections = [];
            try {
                for (var _j = (e_4 = void 0, __values(block.sections)), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var section = _k.value;
                    var lineItems = [];
                    try {
                        for (var _l = (e_5 = void 0, __values(section.lineItems)), _m = _l.next(); !_m.done; _m = _l.next()) {
                            var lineItem = _m.value;
                            var base = 0;
                            if (lineItem.price.type === "fixed") {
                                base = lineItem.price.value;
                            }
                            else if (lineItem.price.type === "legacy") {
                                var quantityField = lineItem.customFields.find(function (f) { return f.id === Types_1.ReservedFieldIds.Quantity; });
                                (0, tiny_invariant_1.default)(quantityField, "Quantity field not found");
                                var itemCostField = lineItem.customFields.find(function (f) { return f.id === Types_1.ReservedFieldIds.Item; });
                                (0, tiny_invariant_1.default)(itemCostField, "Item cost field not found");
                                (0, tiny_invariant_1.default)(itemCostField.strategy === "fixed", "Currency strategy ".concat(itemCostField.strategy, " is not implemented"));
                                base = itemCostField.value * quantityField.value;
                            }
                            lineItems.push({
                                id: lineItem.id,
                                name: lineItem.name,
                                total: __assign(__assign({}, (lineItem.billing.type === "one-off-and-recurring"
                                    ? (_e = {},
                                        _e["one-off"] = {
                                            base: base,
                                            discounts: [],
                                            quoted: base,
                                            taxes: [],
                                            billable: 0,
                                        },
                                        _e) : {})), (_f = {}, _f[lineItem.billing.type === "one-off" ? "one-off" : lineItem.billing.frequency] = {
                                    base: base,
                                    discounts: [],
                                    quoted: base,
                                    taxes: [],
                                    billable: 0,
                                }, _f)),
                                includedInQuote: lineItem.selection.mode === "required" || lineItem.selection.selected,
                            });
                        }
                    }
                    catch (e_5_1) { e_5 = { error: e_5_1 }; }
                    finally {
                        try {
                            if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                        }
                        finally { if (e_5) throw e_5.error; }
                    }
                    sections.push({
                        id: section.id,
                        name: section.name,
                        total: stubTotals(lineItems, ctx),
                        includedInQuote: section.selection.mode === "required" || section.selection.selected,
                        lineItems: lineItems,
                    });
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                }
                finally { if (e_4) throw e_4.error; }
            }
            blocks.push({
                id: block.id,
                name: block.name,
                total: stubTotals(sections, ctx),
                sections: sections,
            });
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
        }
        finally { if (e_3) throw e_3.error; }
    }
    var result = {
        total: stubTotals(blocks, ctx),
        blocks: blocks,
    };
    return result;
};
var zipQuotePairs = function (quoteSummaries, priceSummaries) {
    var result = [];
    for (var i = 0; i < quoteSummaries.length; i++) {
        var quoteSummary = quoteSummaries[i];
        var priceSummary = priceSummaries[i];
        (0, tiny_invariant_1.default)(!!quoteSummary && !!priceSummary, "Quote and Price summaries must be of the same length");
        result.push({ quoteSummary: quoteSummary, priceSummary: priceSummary });
    }
    return result;
};
var getNestedItems = function (pair) {
    if ("blocks" in pair.quoteSummary && "blocks" in pair.priceSummary) {
        return zipQuotePairs(pair.quoteSummary.blocks, pair.priceSummary.blocks);
    }
    if ("sections" in pair.quoteSummary && "sections" in pair.priceSummary) {
        return zipQuotePairs(pair.quoteSummary.sections, pair.priceSummary.sections);
    }
    if ("lineItems" in pair.quoteSummary && "lineItems" in pair.priceSummary) {
        return zipQuotePairs(pair.quoteSummary.lineItems, pair.priceSummary.lineItems);
    }
    return null;
};
exports.getNestedItems = getNestedItems;
var recalculateTotal = function (pair, _a) {
    var e_6, _b;
    var _c, _d;
    var ctx = _a.ctx;
    var nestedItems = (0, exports.getNestedItems)(pair);
    var _loop_1 = function (frequency) {
        var total = pair.priceSummary.total[frequency];
        (0, tiny_invariant_1.default)(total);
        if (nestedItems) {
            total.base = roundOffMoney(nestedItems.reduce(function (sum, item) {
                var _a, _b;
                if ("includedInQuote" in item.priceSummary && !item.priceSummary.includedInQuote) {
                    return sum;
                }
                return roundOffMoney(sum + ((_b = (_a = item.priceSummary.total[frequency]) === null || _a === void 0 ? void 0 : _a.quoted) !== null && _b !== void 0 ? _b : 0), ctx.currency);
            }, 0), ctx.currency);
        }
        var totalSelfDiscounts = (_c = total.discounts.reduce(function (sum, discount) { return (discount.target === "self" ? roundOffMoney(sum + discount.amount, ctx.currency) : sum); }, 0)) !== null && _c !== void 0 ? _c : 0;
        var totalInheritedDiscounts = (_d = total.discounts.reduce(function (sum, discount) { return (discount.target === "parent" ? roundOffMoney(sum + discount.amount, ctx.currency) : sum); }, 0)) !== null && _d !== void 0 ? _d : 0;
        var totalTaxes = total.taxes.reduce(function (sum, tax) { return sum + tax.amount; }, 0);
        total.quoted = roundOffMoney(total.base - totalSelfDiscounts, ctx.currency);
        if (!("includedInQuote" in pair.priceSummary) || pair.priceSummary.includedInQuote) {
            total.billable = roundOffMoney(total.quoted - totalInheritedDiscounts + totalTaxes, ctx.currency);
        }
        else {
            total.billable = 0;
        }
    };
    try {
        for (var _e = __values(Object.keys(pair.priceSummary.total)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var frequency = _f.value;
            _loop_1(frequency);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_6) throw e_6.error; }
    }
};
var applyDiscount = function (pair, _a) {
    var _b, _c, _d;
    var discount = _a.discount, target = _a.target, frequency = _a.frequency, amount = _a.amount, ctx = _a.ctx;
    var frequencyTotal = (_c = (_b = pair.priceSummary.total[frequency]) === null || _b === void 0 ? void 0 : _b.quoted) !== null && _c !== void 0 ? _c : 0;
    var discountAmount = amount;
    if (discountAmount === undefined) {
        if (discount.amountType === "percentage") {
            discountAmount = roundOffMoney((frequencyTotal * discount.amount) / 100, ctx.currency);
        }
        if (discount.amountType === "flat") {
            discountAmount = Math.min(discount.amount, frequencyTotal);
        }
    }
    (0, tiny_invariant_1.default)(discountAmount !== undefined, "Discount amount type ".concat(discount.amountType, " is not supported"));
    var nestedItems = (0, exports.getNestedItems)(pair);
    if (nestedItems) {
        var frequencyItems_1 = nestedItems.filter(function (item) {
            return !!item.priceSummary.total[frequency] &&
                (!("includedInQuote" in item.priceSummary) || item.priceSummary.includedInQuote);
        });
        var remainingDiscountAmount_1 = discountAmount;
        frequencyItems_1.forEach(function (item, index) {
            var _a;
            var total = item.priceSummary.total[frequency];
            (0, tiny_invariant_1.default)(total);
            var quotedTotal = total.quoted;
            var totalDiscounts = (_a = total.discounts.reduce(function (sum, discount) { return roundOffMoney(sum + discount.amount, ctx.currency); }, 0)) !== null && _a !== void 0 ? _a : 0;
            var discountedTotal = roundOffMoney(quotedTotal - totalDiscounts, ctx.currency);
            if (index === frequencyItems_1.length - 1) {
                applyDiscount(item, { discount: discount, target: "parent", frequency: frequency, amount: remainingDiscountAmount_1, ctx: ctx });
            }
            else {
                var portion = roundOffMoney((discountedTotal / frequencyTotal) * discountAmount, ctx.currency);
                applyDiscount(item, { discount: discount, target: "parent", frequency: frequency, amount: portion, ctx: ctx });
                remainingDiscountAmount_1 = roundOffMoney(remainingDiscountAmount_1 - portion, ctx.currency);
            }
        });
    }
    (_d = pair.priceSummary.total[frequency]) === null || _d === void 0 ? void 0 : _d.discounts.push({
        discount: discount,
        amount: discountAmount,
        target: target,
    });
    recalculateTotal(pair, { ctx: ctx });
};
var applyDiscounts = function (pair, _a) {
    var e_7, _b, e_8, _c;
    var ctx = _a.ctx;
    var nestedItems = (0, exports.getNestedItems)(pair);
    if (nestedItems) {
        try {
            for (var nestedItems_1 = __values(nestedItems), nestedItems_1_1 = nestedItems_1.next(); !nestedItems_1_1.done; nestedItems_1_1 = nestedItems_1.next()) {
                var nestedItem = nestedItems_1_1.value;
                applyDiscounts(nestedItem, { ctx: ctx });
            }
        }
        catch (e_7_1) { e_7 = { error: e_7_1 }; }
        finally {
            try {
                if (nestedItems_1_1 && !nestedItems_1_1.done && (_b = nestedItems_1.return)) _b.call(nestedItems_1);
            }
            finally { if (e_7) throw e_7.error; }
        }
        recalculateTotal(pair, { ctx: ctx });
    }
    var _loop_2 = function (discount) {
        var e_9, _f;
        var discountToApply = undefined;
        if (discount.type === "reference") {
            var foundDiscount = ctx.discounts.find(function (d) { return d.id === discount.id; });
            (0, tiny_invariant_1.default)(foundDiscount, "Discount with id ".concat(discount.id, " not found in context"));
            discountToApply = {
                type: "saved",
                id: discount.id,
                name: foundDiscount.name,
                amountType: foundDiscount.amountType,
                amount: foundDiscount.amount,
            };
        }
        else if (discount.type === "custom") {
            discountToApply = {
                type: "custom",
                name: discount.name,
                amountType: discount.amountType,
                amount: discount.amount,
            };
        }
        (0, tiny_invariant_1.default)(discountToApply, "Discount type ".concat(discount.type, " is not supported"));
        try {
            for (var _g = (e_9 = void 0, __values(Object.keys(pair.priceSummary.total))), _h = _g.next(); !_h.done; _h = _g.next()) {
                var frequency = _h.value;
                applyDiscount(pair, { discount: discountToApply, target: "self", frequency: frequency, ctx: ctx });
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_f = _g.return)) _f.call(_g);
            }
            finally { if (e_9) throw e_9.error; }
        }
    };
    try {
        for (var _d = __values(pair.quoteSummary.priceContext.discounts), _e = _d.next(); !_e.done; _e = _d.next()) {
            var discount = _e.value;
            _loop_2(discount);
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
        }
        finally { if (e_8) throw e_8.error; }
    }
};
var applyTaxes = function (pair, _a) {
    var e_10, _b, e_11, _c, e_12, _d, e_13, _e, e_14, _f;
    var _g, _h, _j, _k, _l, _m, _o;
    var _p = _a.taxes, taxes = _p === void 0 ? [] : _p, ctx = _a.ctx;
    var nestedItems = (0, exports.getNestedItems)(pair);
    var taxesToApply = (0, lodash_1.uniq)(__spreadArray(__spreadArray([], __read(taxes), false), __read(pair.quoteSummary.priceContext.taxes.map(function (tax) { return tax.id; })), false).filter(function (tax) {
        return (!("taxExemptions" in pair.quoteSummary.priceContext) ||
            !pair.quoteSummary.priceContext.taxExemptions.some(function (exemption) { return exemption.id === tax; }));
    }));
    if (nestedItems) {
        try {
            for (var nestedItems_2 = __values(nestedItems), nestedItems_2_1 = nestedItems_2.next(); !nestedItems_2_1.done; nestedItems_2_1 = nestedItems_2.next()) {
                var nestedItem = nestedItems_2_1.value;
                if ("includedInQuote" in nestedItem.priceSummary && !nestedItem.priceSummary.includedInQuote) {
                    continue;
                }
                applyTaxes(nestedItem, { taxes: taxesToApply, ctx: ctx });
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (nestedItems_2_1 && !nestedItems_2_1.done && (_b = nestedItems_2.return)) _b.call(nestedItems_2);
            }
            finally { if (e_10) throw e_10.error; }
        }
        try {
            for (var _q = __values(Object.keys(pair.priceSummary.total)), _r = _q.next(); !_r.done; _r = _q.next()) {
                var frequency = _r.value;
                var taxes_1 = [];
                try {
                    for (var nestedItems_3 = (e_12 = void 0, __values(nestedItems)), nestedItems_3_1 = nestedItems_3.next(); !nestedItems_3_1.done; nestedItems_3_1 = nestedItems_3.next()) {
                        var nestedItem = nestedItems_3_1.value;
                        var _loop_3 = function (tax) {
                            var existingTax = taxes_1.find(function (t) { return t.tax.id === tax.tax.id; });
                            if (!existingTax) {
                                taxes_1.push((0, lodash_1.cloneDeep)(tax));
                            }
                            else {
                                existingTax.amount = roundOffMoney(existingTax.amount + tax.amount, ctx.currency);
                            }
                        };
                        try {
                            for (var _s = (e_13 = void 0, __values((_h = (_g = nestedItem.priceSummary.total[frequency]) === null || _g === void 0 ? void 0 : _g.taxes) !== null && _h !== void 0 ? _h : [])), _t = _s.next(); !_t.done; _t = _s.next()) {
                                var tax = _t.value;
                                _loop_3(tax);
                            }
                        }
                        catch (e_13_1) { e_13 = { error: e_13_1 }; }
                        finally {
                            try {
                                if (_t && !_t.done && (_e = _s.return)) _e.call(_s);
                            }
                            finally { if (e_13) throw e_13.error; }
                        }
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (nestedItems_3_1 && !nestedItems_3_1.done && (_d = nestedItems_3.return)) _d.call(nestedItems_3);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
                var pairPriceSummaryTotal = pair.priceSummary.total[frequency];
                (0, tiny_invariant_1.default)(pairPriceSummaryTotal, "Total for frequency ".concat(frequency, " not found in pair"));
                pairPriceSummaryTotal.taxes = taxes_1;
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_c = _q.return)) _c.call(_q);
            }
            finally { if (e_11) throw e_11.error; }
        }
        recalculateTotal(pair, { ctx: ctx });
    }
    if (!nestedItems) {
        var _loop_4 = function (taxId) {
            var e_15, _u;
            var tax = ctx.taxes.find(function (tax) { return tax.id === taxId; });
            (0, tiny_invariant_1.default)(tax, "Tax with id ".concat(taxId, " not found in context"));
            try {
                for (var _v = (e_15 = void 0, __values(Object.keys(pair.priceSummary.total))), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var frequency = _w.value;
                    var frequencyTotal = ((_k = (_j = pair.priceSummary.total[frequency]) === null || _j === void 0 ? void 0 : _j.quoted) !== null && _k !== void 0 ? _k : 0) -
                        ((_m = (_l = pair.priceSummary.total[frequency]) === null || _l === void 0 ? void 0 : _l.discounts.reduce(function (sum, discount) { return roundOffMoney(sum + (discount.target === "parent" ? discount.amount : 0), ctx.currency); }, 0)) !== null && _m !== void 0 ? _m : 0);
                    var taxAmount = roundOffMoney((frequencyTotal * tax.rate) / 100, ctx.currency);
                    (_o = pair.priceSummary.total[frequency]) === null || _o === void 0 ? void 0 : _o.taxes.push({
                        tax: tax,
                        amount: taxAmount,
                    });
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_u = _v.return)) _u.call(_v);
                }
                finally { if (e_15) throw e_15.error; }
            }
        };
        try {
            for (var taxesToApply_1 = __values(taxesToApply), taxesToApply_1_1 = taxesToApply_1.next(); !taxesToApply_1_1.done; taxesToApply_1_1 = taxesToApply_1.next()) {
                var taxId = taxesToApply_1_1.value;
                _loop_4(taxId);
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (taxesToApply_1_1 && !taxesToApply_1_1.done && (_f = taxesToApply_1.return)) _f.call(taxesToApply_1);
            }
            finally { if (e_14) throw e_14.error; }
        }
        recalculateTotal(pair, { ctx: ctx });
    }
};
var calculatePriceSummary = function (quoteSummary, ctx) {
    var priceSummary = buildBasePriceSummary(quoteSummary, { ctx: ctx });
    applyDiscounts({ quoteSummary: quoteSummary, priceSummary: priceSummary }, { ctx: ctx });
    applyTaxes({ quoteSummary: quoteSummary, priceSummary: priceSummary }, { ctx: ctx });
    return priceSummary;
};
exports.calculatePriceSummary = calculatePriceSummary;
var transformDiscount = function (quoteDiscount, discountResolver) {
    if (!(quoteDiscount === null || quoteDiscount === void 0 ? void 0 : quoteDiscount.enabled)) {
        return null;
    }
    if ("id" in quoteDiscount) {
        if (!discountResolver[quoteDiscount.id]) {
            return null;
        }
        return { type: "reference", id: quoteDiscount.id };
    }
    else {
        return {
            type: "custom",
            amountType: quoteDiscount.type === "percent" ? "percentage" : "flat",
            amount: Math.abs(quoteDiscount.units || 0),
            name: "custom discount",
        };
    }
};
var getBillableLineItems = function (pair) {
    var e_16, _a;
    var nestedItems = (0, exports.getNestedItems)(pair);
    if (nestedItems) {
        var billableLineItems = [];
        try {
            for (var nestedItems_4 = __values(nestedItems), nestedItems_4_1 = nestedItems_4.next(); !nestedItems_4_1.done; nestedItems_4_1 = nestedItems_4.next()) {
                var nestedItem = nestedItems_4_1.value;
                if ("includedInQuote" in nestedItem.priceSummary && !nestedItem.priceSummary.includedInQuote) {
                    continue;
                }
                billableLineItems.push.apply(billableLineItems, __spreadArray([], __read((0, exports.getBillableLineItems)(nestedItem)), false));
            }
        }
        catch (e_16_1) { e_16 = { error: e_16_1 }; }
        finally {
            try {
                if (nestedItems_4_1 && !nestedItems_4_1.done && (_a = nestedItems_4.return)) _a.call(nestedItems_4);
            }
            finally { if (e_16) throw e_16.error; }
        }
        return billableLineItems;
    }
    var quoteSummary = pair.quoteSummary, priceSummary = pair.priceSummary;
    if (!("price" in quoteSummary && "includedInQuote" in priceSummary && priceSummary.includedInQuote)) {
        return [];
    }
    var unitAmountField = quoteSummary.customFields.find(function (f) { return f.label === "__qwilrpay_unit_amount"; });
    var quantityField = quoteSummary.customFields.find(function (f) { return f.label === "__qwilrpay_quantity"; });
    if (!((unitAmountField === null || unitAmountField === void 0 ? void 0 : unitAmountField.type) === "number" &&
        unitAmountField.value >= 0 &&
        (quantityField === null || quantityField === void 0 ? void 0 : quantityField.type) === "number" &&
        quantityField.value > 0)) {
        return [];
    }
    return [
        {
            id: quoteSummary.id,
            name: quoteSummary.name,
            unitAmount: unitAmountField.value,
            quantity: quantityField.value,
            total: priceSummary.total,
        },
    ];
};
exports.getBillableLineItems = getBillableLineItems;
var v2Transformer = function (quote, discountResolver, taxResolver, variableResolver) {
    var e_17, _a, e_18, _b, e_19, _c;
    var _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var blockTaxes = [];
    if (quote.settings && quote.settings.enabledTaxes) {
        try {
            for (var _o = __values(Object.entries(quote.settings.enabledTaxes)), _p = _o.next(); !_p.done; _p = _o.next()) {
                var _q = __read(_p.value, 2), id = _q[0], enabled = _q[1];
                if (enabled && taxResolver[id]) {
                    blockTaxes.push({ id: id });
                }
            }
        }
        catch (e_17_1) { e_17 = { error: e_17_1 }; }
        finally {
            try {
                if (_p && !_p.done && (_a = _o.return)) _a.call(_o);
            }
            finally { if (e_17) throw e_17.error; }
        }
    }
    var blockDiscount = transformDiscount(quote.discount, discountResolver);
    var blockDiscounts = blockDiscount ? [blockDiscount] : [];
    var sections = [];
    try {
        for (var _r = __values(quote.sections), _s = _r.next(); !_s.done; _s = _r.next()) {
            var section = _s.value;
            var sectionDiscount = transformDiscount(section.discount, discountResolver);
            var sectionDiscounts = sectionDiscount ? [sectionDiscount] : [];
            var sectionLineItems = [];
            try {
                for (var _t = (e_19 = void 0, __values(section.items)), _u = _t.next(); !_u.done; _u = _t.next()) {
                    var item = _u.value;
                    var name = ((_e = (_d = item.description.tokens) === null || _d === void 0 ? void 0 : _d.find(function (t) { return t.subType === "text"; })) === null || _e === void 0 ? void 0 : _e["content"]) || "";
                    if (item.type === Types_2.QuoteItemType.FixedCost) {
                        var itemDiscount = transformDiscount(item.discount, discountResolver);
                        var itemDiscounts = itemDiscount ? [itemDiscount] : [];
                        var unitAmount = item.rate.rate;
                        var quantity = item.quantity || 0;
                        sectionLineItems.push({
                            id: "",
                            price: {
                                id: "price",
                                label: "",
                                visible: true,
                                type: "fixed",
                                value: unitAmount * quantity,
                                currencyFormat: { type: "match-page" },
                                excludeFromTotal: false,
                            },
                            billing: ((_f = item.billingSchedule) === null || _f === void 0 ? void 0 : _f.type) === Types_2.BillingScheduleType.Recurring
                                ? {
                                    type: "recurring",
                                    frequency: item.billingSchedule.frequency,
                                }
                                : {
                                    type: "one-off",
                                },
                            customFields: __spreadArray([
                                {
                                    label: "__qwilrpay_unit_amount",
                                    id: "__qwilrpay_unit_amount",
                                    type: "number",
                                    userEditable: false,
                                    value: unitAmount,
                                    visible: false,
                                    unit: item.rate.unit,
                                },
                                {
                                    label: "__qwilrpay_quantity",
                                    id: "__qwilrpay_quantity",
                                    type: "number",
                                    userEditable: false,
                                    value: quantity,
                                    visible: false,
                                    unit: item.rate.unit,
                                }
                            ], __read((item.integrations
                                ? [
                                    {
                                        label: "crm_object_type",
                                        id: "crm_object_type",
                                        type: "string",
                                        userEditable: false,
                                        value: item.integrations.object.objectType,
                                        visible: false,
                                    },
                                    {
                                        label: "crm_object_id",
                                        id: "crm_object_id",
                                        type: "string",
                                        userEditable: false,
                                        value: item.integrations.object.objectId,
                                        visible: false,
                                    },
                                ]
                                : [])), false),
                            selection: ((_g = item.interactive) === null || _g === void 0 ? void 0 : _g.isOptional)
                                ? {
                                    mode: "optional",
                                    selected: ((_h = item.interactive) === null || _h === void 0 ? void 0 : _h.isOptionalSelected) || false,
                                    requireChoice: false,
                                    singleSelect: false,
                                }
                                : {
                                    mode: "required",
                                },
                            priceContext: {
                                discounts: itemDiscounts,
                                taxes: [],
                                taxExemptions: item.isTaxExempt ? __spreadArray([], __read(blockTaxes), false) : [],
                            },
                            name: name,
                        });
                    }
                    if (item.type === Types_2.QuoteItemType.Variable && ((_j = item.rate) === null || _j === void 0 ? void 0 : _j.variableId)) {
                        var variable = variableResolver[item.rate.variableId];
                        if (!variable) {
                            continue;
                        }
                        var itemDiscount = transformDiscount(item.discount, discountResolver);
                        var itemDiscounts = itemDiscount ? [itemDiscount] : [];
                        var quantity = item.quantity || 0;
                        var unitAmount = variable.getAmount(quantity);
                        sectionLineItems.push({
                            id: "",
                            price: {
                                id: "price",
                                label: variable.name,
                                visible: true,
                                type: "fixed",
                                value: unitAmount * quantity,
                                currencyFormat: { type: "match-page" },
                                excludeFromTotal: false,
                            },
                            billing: ((_k = item.billingSchedule) === null || _k === void 0 ? void 0 : _k.type) === Types_2.BillingScheduleType.Recurring
                                ? {
                                    type: "recurring",
                                    frequency: item.billingSchedule.frequency,
                                }
                                : {
                                    type: "one-off",
                                },
                            customFields: [
                                {
                                    label: "__qwilrpay_unit_amount",
                                    id: "__qwilrpay_unit_amount",
                                    type: "number",
                                    userEditable: false,
                                    value: unitAmount,
                                    visible: false,
                                    unit: variable.unitName,
                                },
                                {
                                    label: "__qwilrpay_quantity",
                                    id: "__qwilrpay_quantity",
                                    type: "number",
                                    userEditable: false,
                                    value: quantity,
                                    visible: false,
                                    unit: variable.unitName,
                                },
                            ],
                            selection: ((_l = item.interactive) === null || _l === void 0 ? void 0 : _l.isOptional)
                                ? {
                                    mode: "optional",
                                    selected: ((_m = item.interactive) === null || _m === void 0 ? void 0 : _m.isOptionalSelected) || false,
                                    requireChoice: false,
                                    singleSelect: false,
                                }
                                : {
                                    mode: "required",
                                },
                            priceContext: {
                                discounts: itemDiscounts,
                                taxes: [],
                                taxExemptions: item.isTaxExempt ? __spreadArray([], __read(blockTaxes), false) : [],
                            },
                            name: name,
                        });
                    }
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (_u && !_u.done && (_c = _t.return)) _c.call(_t);
                }
                finally { if (e_19) throw e_19.error; }
            }
            sections.push({
                selection: section.mandatory || quote.selectionType === Types_2.QuoteSelectionType.Combined
                    ? {
                        mode: "required",
                    }
                    : {
                        mode: "optional",
                        selected: section.selected || false,
                        requireChoice: Boolean(quote.settings.isSelectionRequired),
                        singleSelect: quote.selectionType === Types_2.QuoteSelectionType.Single,
                    },
                priceContext: {
                    discounts: sectionDiscounts,
                    taxes: [],
                    taxExemptions: [],
                },
                id: "",
                lineItems: sectionLineItems,
                name: "",
            });
        }
    }
    catch (e_18_1) { e_18 = { error: e_18_1 }; }
    finally {
        try {
            if (_s && !_s.done && (_b = _r.return)) _b.call(_r);
        }
        finally { if (e_18) throw e_18.error; }
    }
    return {
        id: "",
        priceContext: {
            discounts: blockDiscounts,
            taxes: blockTaxes,
            taxExemptions: [],
        },
        sections: sections,
        name: "",
    };
};
exports.v2Transformer = v2Transformer;
